import Nullstack from 'nullstack'
import "./menu.css";

export default function Menu() {
  return (
    <>
      <section>
          <div class="text-center text-red-700 m-auto p-5 text-2xl">O curso está com valor promocional por 12x de R$30,72</div>
        <header>
          <div class="menu-container">
            <div class="menu-logo">
              <a href="/curso-de-python"><img src="/TipsCodelogo.png" alt="Logo TipsCode" /></a>
            </div>
           
          </div>
        </header>   
      </section>
    </>
  );
}